export * from './MuteIcon';
export { default } from './MuteIcon';
